const STORAGE_KEY = 'allo:oauth-consent-return';

export function saveOAuthConsentReturn(pathAndSearch: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, pathAndSearch);
  } catch {
    // sessionStorage unavailable (private mode, quota); consent flow will surface its own error
  }
}

export function consumeOAuthConsentReturn(): string | null {
  let raw: string | null;
  try {
    raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    return null;
  }
  if (!raw) {
    return null;
  }
  // Same-origin guard: only site-relative paths, never absolute or protocol-relative URLs.
  // Browsers normalise `\` to `/` in some URL contexts, so reject both `//` and `/\` after the leading slash.
  if (!/^\/(?![/\\])/.test(raw)) {
    return null;
  }
  return raw;
}
